import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import default_vertical_img from "../../assets/placehoder_vertical.png";
import default_horizontal_img from "../../assets/placehoder_horizontal.png";
import premium from "../../assets/Premium.png";
import rent from "../../assets/Rent.png";
import imgLive from "../../assets/img_live.gif";
import castcrew from "../../assets/cast&crew.png";
import Wrapper from "../../components/shared/Wrapper";
import upcomingImg from "../../assets/upcoming.png";
import dotIcon from "../../assets/dotIcon.png";


let resolution = window.RESOLUTION;

const WatchListMarkupGrid = ({
  onUpButtonPress,
  onDownButtonPress,
  items,
  onItemSelected,
  rowWidth,
  rowHeight,
  columnWidth,
  columnHeight,
  itemWidth,
  itemHeight,
  border,
  numberOfColumnsEachRow,
  numberOfDefaultRows,
  selectionColor,
  selectionStyle,
  gapBetweenColumns,
  gapBetweenRows,
  columnBgColorOrImage,
  rowBgColorOrImage,
  shouldScrollHorizontally,
  shouldScrollVertically,
  scrollDuration,
  GridXCordinate,
  GridYCordinate,
  shouldFocus,
  callBack,
  itemComponentName,
  handleUPButton,
  onSelect,
  AppLanguage,
  forceThumbnailType,
  handleLeft,
  navigate,
  SelectedLangauge,
  handleBack2,
  isLiveChannel,
  isLogedIn,
  page,
  pageNumber,
  setPageNumber,
  loading,
  lastFocusedElement1,
  lastFocusedElement,
  rememberFocus,
  setRememberFocus,
  onFocusNeeded,
}) => {
  const [selectedItem, setSelectedItem] = useState({ row: 0, col: 0 });
  const [visibleStartIndex, setVisibleStartIndex] = useState(0);
  const totalRows = Math.ceil(items?.length / numberOfColumnsEachRow);
  const [selectedImageSrc, setSelectedImageSrc] = useState("");
  const gridContainerRef = useRef(null);
  const rowRefs = useRef([]);
  const [isScrolling, setIsScrolling] = useState(false);

  console.log(itemComponentName,"checkingCompone")

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    let formattedTime = "";
    if (hours > 0) {
      formattedTime += `${hours}h `;
    }
    if (minutes > 0) {
      formattedTime += `${minutes}m `;
    }
    return formattedTime.trim();
  };

  const getRowScrollHeight = () => {
    return rowHeight + gapBetweenRows;
  };


  const scrollToRow = (rowIndex) => {
    if (!gridContainerRef.current || isScrolling) return;

    const container = gridContainerRef.current;
    const rowScrollHeight = getRowScrollHeight();
    const totalContentHeight = totalRows * rowScrollHeight;
    const containerHeight = container.clientHeight;
    if (totalContentHeight <= containerHeight) {
      return;
    }

    setIsScrolling(true);

    const targetScrollTop = rowIndex * rowScrollHeight;

    container.scrollTo({
      top: targetScrollTop,
      behavior: 'smooth'
    });

    const newVisibleStart = Math.floor(targetScrollTop / rowScrollHeight);
    setVisibleStartIndex(newVisibleStart);

    setTimeout(() => {
      setIsScrolling(false);
    }, scrollDuration || 300);
  };

  const handleKeyDown = (event) => {
    if (isScrolling) return;
    
    switch (event.keyCode) {
      case 38: // Up Arrow
        if (shouldScrollVertically && selectedItem.row > 0) {
          const newRow = Math.max(selectedItem.row - 1, 0);
          const itemsInNewRow = items.slice(
            newRow * numberOfColumnsEachRow,
            (newRow + 1) * numberOfColumnsEachRow
          ).length;
          
          const newCol = Math.min(selectedItem.col, itemsInNewRow - 1);
          
          setSelectedItem({ row: newRow, col: newCol });
          
          if (newRow < visibleStartIndex) {
            scrollToRow(Math.max(0, newRow));
          }
        } else if (selectedItem.row === 0 && handleUPButton) {
          window.removeEventListener("keydown", handleKeyDown);
          handleUPButton("HandleUPButton");
        }
        else {
          onUpButtonPress();
          console.log("onUpButtonPress={handleMarkupGridUPButton}")
        }
        break;

      case 40: // Down Arrow
        if (loading) break;
        
        if (shouldScrollVertically && selectedItem.row < totalRows - 1) {
          const newRow = Math.min(selectedItem.row + 1, totalRows - 1);
          const itemsInNewRow = items.slice(
            newRow * numberOfColumnsEachRow,
            (newRow + 1) * numberOfColumnsEachRow
          ).length;
          
          if (itemsInNewRow === 0) break;
          
          const newCol = Math.min(selectedItem.col, itemsInNewRow - 1);
          
          setSelectedItem({ row: newRow, col: newCol });
          
          if (newRow >= visibleStartIndex + numberOfDefaultRows) {
            scrollToRow(newRow - numberOfDefaultRows + 1);
          }

          const isLastVisibleRow = newRow >= totalRows - 1;
          if (isLastVisibleRow && (itemComponentName !== "AppLanguageWidget") && forceThumbnailType !== "castcrew" && itemComponentName !== "EpisodesWidget" && itemComponentName !== "SimilarToThis") {
                console.log("Reached last row → load next page", itemComponentName);
                if (isLastVisibleRow && !loading) {
                  setPageNumber((prevPage) => prevPage + 1);
                }
              }
        }
        break;

      case 37: // Left Arrow
        if (itemComponentName === "SearchWidget" && selectedItem.col === 0 && selectedItem.row === 0) {
          callBack("Grid");
          scrollToRow(0);
          setSelectedItem({ row: 0, col: 0 });
          break;
        }

        if (selectedItem.col > 0) {
          setSelectedItem((prev) => ({
            row: prev.row,
            col: prev.col - 1
          }));
        } else if (selectedItem.row > 0) {
          const newRow = selectedItem.row - 1;
          const itemsInNewRow = items.slice(
            newRow * numberOfColumnsEachRow,
            (newRow + 1) * numberOfColumnsEachRow
          ).length;
          
          setSelectedItem({
            row: newRow,
            col: itemsInNewRow - 1
          });
          
          if (newRow < visibleStartIndex) {
            scrollToRow(newRow);
          }
        } else if (selectedItem.row === 0 && selectedItem.col === 0) {
          if (handleLeft !== false) {
            callBack("Grid");
          }
        }
        break;

      case 39: // Right Arrow
        const currentRowItems = items.slice(
          selectedItem.row * numberOfColumnsEachRow,
          (selectedItem.row + 1) * numberOfColumnsEachRow
        ).length;
        
        if (selectedItem.col < currentRowItems - 1) {
          setSelectedItem((prev) => ({
            row: prev.row,
            col: prev.col + 1
          }));
        } else if (selectedItem.row < totalRows - 1) {
          const newRow = selectedItem.row + 1;
          setSelectedItem({
            row: newRow,
            col: 0
          });
          
          if (newRow >= visibleStartIndex + numberOfDefaultRows) {
            scrollToRow(newRow - numberOfDefaultRows + 1);
          }
        }
        break;

      case 13: // Enter key
        const itemIndex = selectedItem.row * numberOfColumnsEachRow + selectedItem.col;
        const clickedItem = items[itemIndex];
        
        if (!clickedItem) break;
        
        if (typeof clickedItem?.artist_type_name === "string") {
          return;
        }
        
        onItemSelected(clickedItem);
        
        if (AppLanguage && clickedItem?.AppLanguage) {
          localStorage.setItem("AppLanguage", clickedItem.AppLanguage);
        }
        
        if (onSelect) onSelect();
        break;

      case 8: // Backspace
      case 10009: // Return
      case 461: // Exit
        if (handleLeft) {
          navigate("HomePage");
        } else {
          callBack("Back");
        }
        break;
        
      default:
        break;
    }
  };

  useEffect(() => {
    if (shouldFocus) {
      const timer = setTimeout(() => {
        window.addEventListener("keydown", handleKeyDown);
      }, 50);
      return () => {
        clearTimeout(timer);
        window.removeEventListener("keydown", handleKeyDown);
      };
    } else {
      window.removeEventListener("keydown", handleKeyDown);
    }
    
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedItem, shouldFocus, items, loading, isScrolling, visibleStartIndex]);

  const getSelectionStyle = (isSelected, item) => {
    if (!isSelected || !shouldFocus) return {};
    
    if (selectionStyle === "border") {
      return { 
        outline: `5px solid ${selectionColor}`,
        borderRadius: '10px',
        outlineOffset: '2px' // Add space between the image and the outline
      };
    } else if (selectionStyle === "zoom") {
      return { 
        transform: "scale(1.1)", 
        transition: "transform 0.2s",
        zIndex: 10 // Ensure zoomed item appears above others
      };
    } else if (selectionStyle === "background" && itemComponentName === "AppLanguageWidget") {
      return { backgroundColor: item?.selectionColor };
    }
    return {};
  };

  const getAppLangaugeStyle = (item) => {
    if (item.AppLanguage === SelectedLangauge) {
      return { backgroundColor: "#EC008C" ,
        borderRadius: "17px" 
      };
    }
  };

  function handleClick(item) {
    console.log("Clicked Item --", item);
    onItemSelected(item);

    if (AppLanguage && item.AppLanguage) {
      localStorage.setItem("AppLanguage", item.AppLanguage);
    }
    if (onSelect) onSelect();
    //     window.GETCONTINUEDATA[0]?.data?.push(
    //   {
    //     season: [
    //       {
    //         episode:item.episode,
    //         number:item.number,
    //       },
    //     ],
    //   }
    // );
  }
  // Helper function to handle mouse enter on an item
  const handleMouseEnter = (rowIndex, colIndex) => {
    if (shouldFocus) {
      setSelectedItem({ row: rowIndex, col: colIndex });
    }
  };

  let userDetails = JSON.parse(localStorage.getItem("user_details"));
  let userProfile = userDetails?.user_profiles?.[0];

  // Common wrapper style function to ensure proper spacing for selection
  const getWrapperStyle = (isSelected, additionalStyles = {}) => ({
    width: columnWidth,
    height: columnHeight,
    margin: `${gapBetweenRows / 2}px ${gapBetweenColumns / 2}px`,
    zIndex: isSelected ? 10 : 1, // Higher z-index for selected items
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: 'relative',
    ...getSelectionStyle(isSelected),
    ...additionalStyles
  });

  // SearchWidget rendering
  if (itemComponentName === "SearchWidget") {
    return (
      <div
        ref={gridContainerRef}
        style={{
          position: 'absolute',
          height: rowHeight * numberOfDefaultRows + gapBetweenRows * (numberOfDefaultRows - 1),
          width: rowWidth,
          marginLeft: GridXCordinate,
          marginTop: GridYCordinate,
          overflow: 'auto',
          scrollBehavior: 'smooth',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          padding: '10px', // Add padding to container to prevent cropping
        }}
        onMouseEnter={onFocusNeeded}
      >
        <style jsx>{`
          div::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: `${gapBetweenRows}px`,
          paddingBottom: '20px',
          minHeight: '100%'
        }}>
          {Array.from({ length: Math.ceil(items.length / numberOfColumnsEachRow) }).map((_, rowIndex) => (
            <div
              key={rowIndex}
              ref={el => rowRefs.current[rowIndex] = el}
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: `${gapBetweenColumns}px`,
                width: rowWidth,
                height: rowHeight,
                background: rowBgColorOrImage,
              }}
            >
              {items
                .slice(
                  rowIndex * numberOfColumnsEachRow,
                  (rowIndex + 1) * numberOfColumnsEachRow
                )
                .map((item, colIndex) => {
                  const isSelected = selectedItem.row === rowIndex && selectedItem.col === colIndex && shouldFocus;
                  
                  return (
                    <Wrapper
                      key={colIndex}
                      onMouseEnter={() => handleMouseEnter(rowIndex, colIndex)}
                      style={getWrapperStyle(isSelected)}
                      onClick={() => handleClick(item)}
                    >
                      <div style={{ 
                        position: "relative", 
                        width: "100%", 
                        height: "100%",
                        overflow: 'visible' // Ensure content isn't clipped
                      }}>
                        <img
                          src={item.thumbnail || default_vertical_img}
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            boxSizing: "border-box",
                            borderRadius: "10px",
                            display: 'block'
                          }}
                          onError={(e) => {
                            if (e.target.src !== default_vertical_img) {
                              e.target.src = default_vertical_img;
                            }
                          }}
                        />
                        {item?.is_paid === 1 && (
                          <img
                            src={premium}
                            alt="Premium Icon"
                            style={{
                              position: "absolute",
                              top: "0.3rem",
                              left:"0.3rem",
                              width: "2.5rem",
                              height: "2.5rem",
                              zIndex: 2,
                            }}
                          />
                        )}
                        {item?.still_live === 1 && item?.is_live === 1 && (
                          <img
                            src={imgLive}
                            alt="Live Icon"
                            style={{
                              position: "absolute",
                              top: "0.5rem",
                              right: "8.8rem",
                              width: "5.2rem",
                              height: "2.1rem",
                              zIndex: 2,
                            }}
                          />
                        )}
                         {item?.still_live === 1 && item?.is_live === 0 && (
                          <img
                            src={upcomingImg}
                            alt="Upcoming Icon"
                            style={{
                              position: "absolute",
                              top: "0.5rem",
                              right: "5.8rem",
                              width: "7vw",
                              height: "2.1rem",
                              zIndex: 2,
                            }}
                          />
                        )}
                        {item?.is_paid === 2 && (
                          <img
                            src={rent}
                            alt="Rent Icon"
                            style={{
                              position: "absolute",
                              top: "0.3rem",
                              left: "0.3rem",
                              width: "2.5rem",
                              height: "2.5rem",
                            }}
                          />
                        )}
                        {item.isTeaser === 1 && (() => {
                          const startTime = parseInt(item?.endtime) * 1000;
                          const now = Date.now();
                          const hoursRemaining = (startTime - now) / (1000 * 60 * 60);
                          const launchesIn24Hours = startTime > 0 && startTime < window.CWPOOLING;

                          return launchesIn24Hours ? (
                            <div style={{
                              position: "absolute",
                              bottom: "10%",
                              left: "50%",
                              transform: "translateX(-50%)",
                              zIndex: 10,
                              background: "#fff",
                              color: "black",
                              padding: "5px 15px",
                              fontSize: "16px",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                              textTransform: "uppercase"
                            }}>
                              {`LAUNCHES IN ${Math.ceil(hoursRemaining)} HOURS`}
                            </div>
                          ) : null;
                        })()}
                        {item?.isTeaser === 1 && (
                          <img
                            src={upcomingImg}
                            alt={item.title}
                            style={{
                              borderRadius: "10px",
                              position: "absolute",
                              width: "10vw",
                              height: "4vh",
                              top: "1vh",
                              right: "1rem",
                              zIndex: 1,
                            }}
                          />
                        )}
                      </div>
                    </Wrapper>
                  );
                })}
            </div>
          ))}
        </div>
      </div>
    );
  } 
  else if (itemComponentName === "SimilarToThis") {
    return (
      <div
        ref={gridContainerRef}
        style={{
          position: 'absolute',
          // height: rowHeight * numberOfDefaultRows + gapBetweenRows * (numberOfDefaultRows - 1),
          height: "100vh",
          width: rowWidth,
          marginLeft: GridXCordinate,
          marginTop: '-20px',
          overflow: 'auto',
          scrollBehavior: 'smooth',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          padding: '10px', // Add padding to container to prevent cropping
        }}
        onMouseEnter={onFocusNeeded}
      >
        <style jsx>{`
          div::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: `${gapBetweenRows}px`,
          paddingBottom: '20px',
          minHeight: '100%'
        }}>
          {Array.from({ length: Math.ceil(items.length / numberOfColumnsEachRow) }).map((_, rowIndex) => (
            <div
              key={rowIndex}
              ref={el => rowRefs.current[rowIndex] = el}
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: `${gapBetweenColumns}px`,
                width: rowWidth,
                height: rowHeight,
                background: rowBgColorOrImage,
              }}
            >
              {items
                .slice(
                  rowIndex * numberOfColumnsEachRow,
                  (rowIndex + 1) * numberOfColumnsEachRow
                )
                .map((item, colIndex) => {
                  const isSelected = selectedItem.row === rowIndex && selectedItem.col === colIndex && shouldFocus;
                  
                  return (
                    <Wrapper
                      key={colIndex}
                      onMouseEnter={() => handleMouseEnter(rowIndex, colIndex)}
                      style={getWrapperStyle(isSelected)}
                      onClick={() => handleClick(item)}
                    >
                      <div style={{ 
                        position: "relative", 
                        width: "100%", 
                        height: "100%",
                        overflow: 'visible' // Ensure content isn't clipped
                      }}>
                        <img
                          src={item.thumbnail || default_vertical_img}
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            boxSizing: "border-box",
                            borderRadius: "10px",
                            display: 'block'
                          }}
                          onError={(e) => {
                            if (e.target.src !== default_vertical_img) {
                              e.target.src = default_vertical_img;
                            }
                          }}
                        />
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          padding: '8px',
                          background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0))',
                          color: 'white',
                          fontSize: '1.5rem',
                          textAlign: 'left',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          borderBottomLeftRadius: '10px',
                          borderBottomRightRadius: '10px'
                        }}>
                          {/* {item.title} */}
                        </div>
                        {item?.is_paid === 1 && (
                          <img
                            src={premium}
                            alt="Premium Icon"
                            style={{
                              position: "absolute",
                              top: "0.3rem",
                              left:"0.3rem",
                              width: "2.5rem",
                              height: "2.5rem",
                              zIndex: 2,
                            }}
                          />
                        )}
                        {item?.still_live === 1 && (
                          <img
                            src={imgLive}
                            alt="Live Icon"
                            style={{
                              position: "absolute",
                              top: "0.5rem",
                              // right: "8.8rem",
                              left:"1rem",
                              width: "5.2rem",
                              height: "2.1rem",
                              zIndex: 2,
                            }}
                          />
                        )}
                        {item?.is_paid === 2 && (
                          <img
                            src={rent}
                            alt="Rent Icon"
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              width: "4rem",
                              height: "4rem",
                            }}
                          />
                        )}
                      
                      </div>
                    </Wrapper>
                  );
                })}
            </div>
          ))}
        </div>
      </div>
    );
  } 
  // AppLanguageWidget rendering
  else if (itemComponentName === "AppLanguageWidget") {
    return (
      <div
        ref={gridContainerRef}
        style={{
          position: 'absolute',
          height: rowHeight * numberOfDefaultRows + gapBetweenRows * (numberOfDefaultRows - 1),
          width: rowWidth,
          marginLeft: GridXCordinate,
          marginTop: GridYCordinate,
          overflow: 'auto',
          scrollBehavior: 'smooth',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          padding: '10px',
        }}
        onMouseEnter={() => { if (callBack) callBack("Grid"); }}
        onMouseLeave={() => { if (callBack) callBack("Back"); }}
      >
        <style jsx>{`
          div::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: `${gapBetweenRows}px`,
          // paddingBottom: '20px',
          minHeight: '100%'
        }}>
          {Array.from({ length: Math.ceil(items.length / numberOfColumnsEachRow) }).map((_, rowIndex) => (
            <div
              key={rowIndex}
              ref={el => rowRefs.current[rowIndex] = el}
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: `${gapBetweenColumns}px`,
                width: rowWidth,
                height: rowHeight,
                background: rowBgColorOrImage,
              }}
            >
              {items
                .slice(
                  rowIndex * numberOfColumnsEachRow,
                  (rowIndex + 1) * numberOfColumnsEachRow
                )
                .map((item, colIndex) => {
                  const isSelected = selectedItem.row === rowIndex && selectedItem.col === colIndex && shouldFocus;
                  
                  return (
                    <Wrapper
                      key={colIndex}
                      onMouseEnter={() => handleMouseEnter(rowIndex, colIndex)}
                      style={{
                        width: itemWidth,
                        height: itemHeight,
                        margin: `${gapBetweenRows / 2}px ${gapBetweenColumns / 2}px`,
                        background: columnBgColorOrImage,
                        border: isSelected ? "2px solid #fff" : "transparent",
                         borderRadius: "18px",
                        ...getSelectionStyle(isSelected, item),
                        ...getAppLangaugeStyle(item),
                        position: 'relative',
                        zIndex: isSelected ? 10 : 1,
                      }}
                      onClick={() => handleClick(item)}
                    >
                      <div style={{ position: "absolute", width: "100%", height: "100%" }}>
                        <img
                          src={item.thumbnail}
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            opacity: 0.6,
                          }}
                        />
                      </div>
                      <div style={styles.title}>
                        <img
                          src={item.title}
                          alt={item.title}
                          style={{ height: "36px" }}
                        />
                      </div>
                      <div style={{
                        position: "absolute",
                        fontSize: "25px",
                        color: "#757575",
                        marginTop: "65px",
                        marginLeft: "35px",
                        fontWeight:500,
                        
                      }}>
                        {"(" + item.subtitle + ")"}
                      </div>
                      <div style={{
                        position: "absolute",
                        marginTop: "80px",
                        marginLeft: "220px",
                      }}>
                        <img
                          src={item.icon}
                          alt={item.title}
                          style={{
                            height: "138px",
                            width: "140px",
                            margin: "0px",
                            padding: "0px",
                            boxShadow: "border-box",
                            filter: isSelected ? "invert(1)" : "none",
                            transition: "filter 0.3s ease",
                          }}
                        />
                      </div>
                    </Wrapper>
                  );
                })}
            </div>
          ))}
        </div>
      </div>
    );
  }
  
  // EpisodesWidget rendering
  else if (itemComponentName === "EpisodesWidget") {
    return (
      <div
        ref={gridContainerRef}
        style={{
          position: 'absolute',
          height: rowHeight * numberOfDefaultRows + gapBetweenRows * (numberOfDefaultRows - 1),
          width: rowWidth,
          marginLeft: GridXCordinate,
          paddingRight: "5rem",
          marginTop: GridYCordinate,
          overflow: 'auto',
          scrollBehavior: 'smooth',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          padding: '10px'
        }}
      >
        <style jsx>{`
          div::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: `${gapBetweenRows}px`,
          // paddingBottom: '20px',
          minHeight: '100%'
        }}>
          {Array.from({ length: Math.ceil(items.length / numberOfColumnsEachRow) }).map((_, rowIndex) => (
            <div
              key={rowIndex}
              ref={el => rowRefs.current[rowIndex] = el}
              style={{
                display: 'grid',
                justifyItems: "center",
                gridTemplateColumns: `repeat(${numberOfColumnsEachRow}, 1fr)`,
                gap: `${gapBetweenRows}px ${gapBetweenColumns}px`,
                width: rowWidth,
                height: rowHeight,
                background: rowBgColorOrImage,
              }}
            >
              {items
                .filter((item) => {
                  if (forceThumbnailType === "episodes") {
                    return !item.title.toLowerCase().includes("trailer");
                  }
                  return true;
                })
                .slice(
                  rowIndex * numberOfColumnsEachRow,
                  (rowIndex + 1) * numberOfColumnsEachRow
                )
                .map((item, colIndex) => {
                  const isSelected = selectedItem.row === rowIndex && selectedItem.col === colIndex && shouldFocus;
                  
                  if (forceThumbnailType === "castcrew") {
                    return (
                      <div
                        key={colIndex}
                        onMouseEnter={() => handleMouseEnter(rowIndex, colIndex)}
                        style={{
                          width: "162.84px",
                          height: columnHeight,
                          width: "160px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "0.2rem",
                          position: 'relative',
                        }}
                      >
                        <Wrapper
                          as="img"
                          src={item.thumbnail || item.poster_url || item.thumbnail_url || castcrew}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = castcrew;
                          }}
                          alt={item.title}
                          style={{
                            height: itemHeight,
                            objectFit: "cover",
                            borderRadius: '10px',
                            objectPosition: "center",
                            ...getSelectionStyle(isSelected),
                            zIndex: isSelected ? 10 : 1,
                          }}
                        />
                        <p style={{
                          color: "#ffffff",
                          fontSize: "1.8rem",
                          textAlign: "center",
                          marginTop: "0.5rem",
                        }}>
                          {item?.title || "Unknown Item"}
                        </p>
                        {item?.video_duration && (
                          <p style={{
                            color: "#ffffff",
                            fontSize: "20px",
                            textAlign: "start",
                            marginTop: "-1.7rem",
                          }}>
                            {formatTime(item?.video_duration)}
                          </p>
                        )}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={colIndex}
                        onMouseEnter={() => handleMouseEnter(rowIndex, colIndex)}
                        style={{
                          width: columnWidth,
                          height: columnHeight,
                          position: 'relative',
                        }}
                      >
                        <Wrapper
                          as="img"
                          onClick={() => handleClick(item)}
                          src={item.poster_url || item.thumbnail || item.thumbnail_url || default_horizontal_img}
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: '10px',
                            objectPosition: "center",
                            ...getSelectionStyle(isSelected),
                            zIndex: isSelected ? 10 : 1,
                          }}
                        />
                        {item?.still_live === 1 && (
                          <img
                            src={imgLive}
                            alt="live Icon"
                            style={{
                              position: "absolute",
                              bottom: "11rem",
                              left: "0.5rem",
                              width: "5rem",
                              height: "2rem",
                              zIndex: 2,
                            }}
                          />
                        )}
                      
                      
                      
                      
                         {(item?.media_type==1||item?.type==1)&&item?.is_live==1?"":(   <p style={{
                          color: "#ffffff",
                          fontSize: "1.8rem",
                          textAlign: "start",
                          marginTop: "0.5rem",
                        }}>
                          {item?.number === undefined ? (
                            item.is_live == 1 ? "" : item?.title
                          ) : (
                            <>
                              {item.is_live == 1 ? "" : item?.title}<br />
                              E{item?.episode ?? ""}
                              {/* <span style={{
                                fontSize: "1.2rem",
                                margin:"0px 8px 8px",
                                position: "relative",
                                bottom: "0.17rem"
                                }} >&nbsp;&#9679;&nbsp;
                                </span> */}
                                <img
                                src={dotIcon}
                                style={{ width: "9px", height: "9px", marginLeft: "8px", marginRight: "8px", marginBottom: "4px", verticalAlign: "middle" }}
 
                              />
                                {formatTime(item?.video_duration) ?? ""}
                            </>
                          )}
                        </p>) }
 
                        {item?.description?.[0]?.content && forceThumbnailType !== "castcrew" && (
                          <p style={{
                            color: "#898989",
                            fontSize: "20px",
                            textAlign: "start",
                            marginTop: "-1.7rem",
                          }}>
                            {item?.is_live == 0 ? item?.description[0]?.content?.split(/\s+/).slice(0, 12).join(" ") + "..." : ""}
                          </p>
                        )}
                      </div>
                    );
                  }
                })}
            </div>
          ))}
        </div>
      </div>
    );
  }
  

};

WatchListMarkupGrid.propTypes = {
  items: PropTypes.array.isRequired,
  onItemSelected: PropTypes.func.isRequired,
  rowWidth: PropTypes.string,
  rowHeight: PropTypes.number,
  columnWidth: PropTypes.number,
  columnHeight: PropTypes.number,
  itemWidth: PropTypes.number,
  itemHeight: PropTypes.number,
  numberOfColumnsEachRow: PropTypes.number,
  numberOfDefaultRows: PropTypes.number,
  selectionColor: PropTypes.string,
  selectionStyle: PropTypes.oneOf(["border", "zoom", "background"]),
  gapBetweenColumns: PropTypes.number,
  gapBetweenRows: PropTypes.number,
  columnBgColorOrImage: PropTypes.string,
  rowBgColorOrImage: PropTypes.string,
  shouldScrollHorizontally: PropTypes.bool,
  shouldScrollVertically: PropTypes.bool,
  scrollDuration: PropTypes.number,
  GridXCordinate: PropTypes.number,
  GridYCordinate: PropTypes.number,
  shouldFocus: PropTypes.bool,
  itemComponentName: PropTypes.string,
  handleMouseLeave: PropTypes.func,
};

const styles = {
  Container: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    margin: "0px",
    padding: "0px",
    boxSizing: "border-box",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "left",
    justifyContent: "left",
  },
  item: {
    textAlign: "center",
    color: "#fff",
    padding: resolution === "FHD" ? "5px" : "3px",
    borderRadius: resolution === "FHD" ? "10px" : "7px",
    transition: "transform 0.2s",
  },
  image: {
    borderRadius: resolution === "FHD" ? "10px" : "7px",
  },
  title: {
    marginTop: resolution === "FHD" ? "20px" : "7px",
    marginLeft: "35px",
    display: "flex",
    position: "absolute",
    background: "transparent",
    height: "57px",
  },
};

export default WatchListMarkupGrid;